import { graphql, useFragment } from "react-relay";
import { TrackOfTheMonthFragment$key } from "./__generated__/TrackOfTheMonthFragment.graphql";
import CompetitionCard from "./CompetitionCard";
import { FormattedMessage } from "react-intl";
const Fragment = graphql`
  fragment TrackOfTheMonthFragment on Query {
    eventCompetitionPinned {
      event {
        slug
      }
      competition {
        ...CompetitionCardFragment
      }
    }
  }
`;
interface Props {
  query: TrackOfTheMonthFragment$key;
}
export function TrackOfTheMonth(props: Props) {
  const track = useFragment(Fragment, props.query);
  if (
    !track.eventCompetitionPinned?.competition ||
    !track.eventCompetitionPinned.event
  )
    return null;
  return (
    <div className="relative w-full pb-16">
      <div className="w-full h-80 relative bg-linear-to-b from-info-500 to-brand-500 rounded-tl-[40px] rounded-br-[40px] overflow-hidden">
        <div className="absolute w-2/3 aspect-square -left-1/4 top-1/4 opacity-5 bg-white rounded-full border-36 border-white" />
        <div className="absolute w-2/3 aspect-square -right-1/4 -top-1/2 opacity-5 bg-white rounded-full border-36 border-white" />
        <div className="absolute top-0 left-0 w-full pt-5 flex flex-col items-center gap-2 z-10">
          <div className="flex flex-col items-center gap-1 px-4">
            <p className="text-white text-2xl font-semibold leading-8 text-center">
              <FormattedMessage defaultMessage="Track of the month" />
            </p>
            <p className="w-full max-w-md text-white text-sm font-normal leading-5 text-center">
              <FormattedMessage defaultMessage="This track is picking up momentum in the community, hurry and jump in while it's active." />
            </p>
          </div>
        </div>
      </div>
      <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 z-10 w-full max-w-3xl px-4 sm:px-0">
        <CompetitionCard
          vertical={false}
          competition={track.eventCompetitionPinned.competition}
          owner={track.eventCompetitionPinned?.event.slug}
        />
      </div>
    </div>
  );
}
